var _circle, _circle2, _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2026(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 236,
    fill: "#DC2626"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 210,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 18,
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 256h440M256 36c-70 65-105 138-105 220s35 155 105 220M256 36c70 65 105 138 105 220s-35 155-105 220",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 14,
    opacity: 0.55
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 290,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 122,
    fontWeight: 700,
    fill: "#ffffff"
  }, "2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2026);
export default __webpack_public_path__ + "static/media/2026.9999711a0360033eb4b2059a601e1abb.svg";
export { ForwardRef as ReactComponent };